module.exports = __webpack_public_path__ + "img/purchases--avatar.8692c7d2.svg";